

import { UserInfo } from "@/interfaces/user-interface";
import { REACT_APP_PUBLIC_DIRECTUS_API } from "@/constants";
import { readMe, createItem } from "@directus/sdk";
import axios from "axios";
import directus from "@/lib/directus";
import client from "@/lib/directus";


export const authService = {
    login: async (
        email: string,
        password: string
    ): Promise<{
        success: boolean;
        error?: Error;
        newUser?: UserInfo;
        redirectTo?: string;
    } | undefined> => {
        try {
            const result = await directus.login(email, password);

            const me = await directus.request(readMe());
            localStorage.setItem('directus_auth', JSON.stringify(result))



            return {
                success: true,
                newUser: me as UserInfo,
                redirectTo: "/dashboard",
            };
        } catch (error: any) {
            return {
                success: false,
                error: new Error(error.message || "Erreur lors de la connexion"),
            };
        }
    },
    register: async (
        email: string,
        password: string,
        phoneNumber: string,
        firstName: string,
        lastName: string
    ): Promise<{
        success: boolean;
        error?: Error;
        redirectTo?: string;
    } | undefined> => {
        try {

            const response = await axios.post(`${REACT_APP_PUBLIC_DIRECTUS_API}/users/register`, {
                email: email,
                password: password,
            }, {
                headers: {
                    "Content-Type": "application/json"
                }
            });

            if ((response.status === 200 || response.status === 204)) {

                const loginResponse = await client.login(email, password)


                localStorage.setItem('directus_auth', JSON.stringify(loginResponse))

                const currentUser = await directus.request(readMe());

                await directus.request(createItem("commercial_relations", {
                    commercial_phoneNumber: phoneNumber,
                    user_id: currentUser.id,
                    nom: lastName,
                    prenom: firstName,
                }));

                return {
                    success: true,
                    redirectTo: "/dashboard",
                }

            } else {
                throw new Error("Email address or password is invalid");
            }



        } catch (error: any) {
            return {
                success: false,
                error: new Error(error.message || "Erreur lors de l'inscription"),
            };
        }
    },



    logout: async (): Promise<void> => {
        try {
            await directus.logout()
        } catch (error: any) {
            console.error("Erreur lors de la déconnexion", error);
        }
    },

    isAuthenticated: (): boolean => {
        return !!localStorage.getItem("access_token");
    },
};
